import {
  GET_COMPANY_SEARCH_EXPERT,
  GET_TEAM_FILE_BYID,
  GET_TEAM_FILE_FOLDER,
  GET_TEAM_MEMBER,
  GET_TEAM_MILESTONE,
  GET_TEAM_OVERVIEW,
  GET_TEAM_PROJECT,
  GET_TEAM_SEARCH_EXPERT,
  GET_TEAM_TASK,
} from "../constants";

export const team = (
  state = {
    getteamprojects: [],
    getteammilestones: [],
    getteamtasks: [],
    getteamoverviews: [],
    getteammemberss: [],
    getteamsearchexperts: [],
    getteamfilefolderlist: [],
    getteamfilelistbyid: [],
    getcompanysearchexperts: [],
  },
  action,
) => {
  switch (action.type) {
    case GET_TEAM_PROJECT:
      return { ...state, getteamprojects: action.getteamprojects };
    case GET_TEAM_MILESTONE:
      return { ...state, getteammilestones: action.getteammilestones };
    case GET_TEAM_TASK:
      return { ...state, getteamtasks: action.getteamtasks };
    case GET_TEAM_OVERVIEW:
      return { ...state, getteamoverviews: action.getteamoverviews };
    case GET_TEAM_MEMBER:
      return { ...state, getteammemberss: action.getteammemberss };
    case GET_TEAM_SEARCH_EXPERT:
      return { ...state, getteamsearchexperts: action.getteamsearchexperts };
    case GET_COMPANY_SEARCH_EXPERT:
      return {
        ...state,
        getcompanysearchexperts: action.getcompanysearchexperts,
      };
    case GET_TEAM_FILE_FOLDER:
      return { ...state, getteamfilefolderlist: action.getteamfilefolderlist };
    case GET_TEAM_FILE_BYID:
      return { ...state, getteamfilelistbyid: action.getteamfilelistbyid };
    default:
      return state;
  }
};
